<div class="faq-image" [style.backgroundImage]="'url(' + faqImage + ')'">
    <div class="flex__container">
        <div class="faq-img-text">
            <h1>Frequently Asked Questions</h1>
        </div>
    </div>
    <div class="overlay-img"></div>
</div>
<div id="faq" class="faq-page">
    <section class="faq-section">
        <div class="flex__container">
            <div class="flex__column">
                <h4 class="faq-title">Applying and Participating - ngGirls</h4>
                <div class="faq-body">
                    <h5 class="faq-subtitle">How can I apply?</h5>
                    <p>Just fill out the application form in the specific event's website - click on "Apply for the
                        workshop". Do you already have experience in front-end development? Apply as a mentor!
                    </p>
                </div>
                <div class="faq-body">
                    <h5 class="faq-subtitle">Where is ngGirls going to take place?</h5>
                    <p>We have many events all around the world. Check the <a href="./">homepage</a> for the upcoming
                        workshops.</p>
                </div>
                <div class="faq-body">
                    <h5 class="faq-subtitle">What is the schedule of the workshop day?</h5>
                    <p>The workshop usually takes place during the day. It starts with an introduction to Angular, and
                        then
                        the work is independent until the closing session, with a lunch break. You will get the updated
                        schedule by mail before the event.
                    </p>
                </div>
                <div class="faq-body">
                    <h5 class="faq-subtitle">What is the criteria for choosing applicants?</h5>
                    <p>You can read about it in our source of inspiration - <a
                            href="http://blog.djangogirls.org/post/91067112853/djangogirls-how-we-scored-applications"
                            target="_blank">Django Girls blog post.</a></p>
                </div>
                <div class="faq-body">
                    <h5 class="faq-subtitle">Do I need prior knowledge in programming?</h5>
                    <p>In the workshop we assume you have basic knowledge in programming. Once you know how it works in
                        one
                        language - it's easy to manage with JavaScript. Basic knowledge in HTML and CSS is also
                        required,
                        but it's really easy to learn.
                    </p>
                </div>
                <div class="faq-body">
                    <h5 class="faq-subtitle">I have no knowledge in programming whatsoever. But I’m willing to learn.
                        Can
                        you recommend me on some resources?</h5>
                    <p>There are many tutorials on the internet for Web development: HTML, CSS and JavaScript. You
                        should
                        get the grasp of how things work.
                        <a target="_blank" href="https://www.codecademy.com/">Codecademy</a> is a good place to start,
                        since it provides a platform for coding while learning.
                    </p>
                </div>
            </div>
        </div>
    </section>

    <section class="faq-section">
        <div class="flex__container">
            <div class="flex__column">
                <h4 class="faq-title">Getting Ready</h4>
                <div class="faq-body">
                    <h5 class="faq-subtitle">Should I bring my own laptop?</h5>
                    <p>Yes! But if you don't have one, make sure you let us know in advance. It is also important for us
                        that you will take home everything you’ll write and create during workshop.
                    </p>
                </div>
                <div class="faq-body">
                    <h5 class="faq-subtitle">Do I need to have something installed on my laptop?</h5>
                    <p>We will send the full pre requirements to the participants prior to the workshop. One of the
                        mentors will help you with the installations before the workshop. You can start now by
                        installing NodeJS, Git and an IDE of your choice, and open an account on Github.</p>
                </div>
                <div class="faq-body">
                    <h5 class="faq-subtitle">What IDE do you recommend?</h5>
                    <p>There are various IDEs you can install with different licenses. Webstorm is very popular, and you
                        can get it with a free trial of a month. Visual Studio Code is another great option which you
                        can get for free!
                    </p>
                </div>
            </div>
        </div>
    </section>

    <section class="faq-section">
        <div class="flex__container">
            <div class="flex__column">
                <h4 class="faq-title">Mentoring</h4>
                <div class="faq-body">
                    <h5 class="faq-subtitle">Can I be a mentor?</h5>
                    <p>Yes, we would love to have your help! If you have some knowledge and experience in front-end
                        development, please fill out the form "call for mentors".
                    </p>
                </div>
                <div class="faq-body">
                    <h5 class="faq-subtitle">Are mentors being paid?</h5>
                    <p>No, mentors, as well as the organizers, volunteer for the workshop.
                    </p>
                </div>
            </div>
        </div>
    </section>

    <section class="faq-section">
        <div class="flex__container">
            <div class="flex__column">
                <h4 class="faq-title">More FAQ</h4>
                <div class="faq-body">
                    <h5 class="faq-subtitle">I've got many more questions!</h5>
                    <p>You can email us: <a href="mailto:hello@ng-girls.org" target="_blank">hello@ng-girls.org</a> and
                        we will be glad to answer any question.
                    </p>
                </div>
            </div>
        </div>
    </section>
</div>